var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:`cv-toolbar-title ${_vm.carbonPrefix}--toolbar-menu__title`},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }